import * as React from 'react';
import { Button } from '@fluentui/react-components';
import { OpenRegular } from '@fluentui/react-icons';
import FolderExplorer from '../components/FolderExplorer';
import { useApp } from '../app/context';

/** Browse the library as it is now; rename folders (logged, undoable). */
export default function Library(): React.ReactElement {
  const app = useApp();
  return (
    <main className="page">
      <div className="page-head">
        <div>
          <h1>Documents</h1>
          <p>{app.workspace.libraryName} library · {app.workspace.siteName}. Moving or renaming a folder goes through a preview and can be undone from History.</p>
        </div>
        {app.workspace.webUrl && (
          <Button as="a" href={app.workspace.webUrl} target="_blank" rel="noreferrer" icon={<OpenRegular />}>Open in SharePoint</Button>
        )}
      </div>
      <FolderExplorer title="Folders" />
    </main>
  );
}
